import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, branch, renderComponent } from 'recompose'
import { push } from 'react-router-redux'

import * as actions from 'modules/user/actions'
import * as selectors from 'modules/user/selectors'
import { page, track } from 'utils/trackingUtils'
import { Flow } from 'constants/flowConstants'

import { PasswordStep, AEPasswordStep } from './component'

const mapStateToProps = state => ({
  flow: selectors.getFlow(state),
  password: selectors.getPassword(state),
  isRepInvitedFlow: selectors.isRepInvitedFlow(state),
  passwordConfig: selectors.passwordConfig(state),
  passwordConfigFetched: selectors.passwordConfigFetched(state),
  passwordUpdateStatus: selectors.passwordUpdateStatus(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setPassword: actions.setPassword,
    updatePassword: actions.updatePassword,
    push,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Password Setup', {
        context: this.props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : this.props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
      })
    },
    componentDidUpdate(prevProps, prevState) {
      if (this.props.passwordUpdateStatus && this.props.passwordUpdateStatus === 'success') {
        // redirect!
        track('Onboarding Password Setup Completed', {
          context: this.props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : this.props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
        })
        if (this.props.isCalendarSeat) {
          this.props.actions.push(`/setup/calendaring/profile`)
        } else if (this.props.flow !== Flow.VIDEO) {
          this.props.actions.push(`/setup/meetings`)
        } else {
          // for video and hyfy migration flows, we let the user epic handle redirecting to drift video
        }
      }
    }
  }),
  withHandlers({
    onPasswordChange: props => event => {
      props.actions.setPassword(event.target.value)
    },
    onContinueClick: props => () => {
      props.actions.updatePassword()
    }
  }),
  branch(props => props.isCalendarSeat, renderComponent(AEPasswordStep)),
)(PasswordStep)



// WEBPACK FOOTER //
// ./src/layouts/PasswordStep/index.js